import * as React from "react";
import type { SVGProps } from "react";
const SvgShoppingCart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 16H7v-2h12c.5 0 .92-.37.99-.86l1-7c.04-.27-.04-.55-.21-.77a.98.98 0 0 0-.71-.37L7 4.07V3c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1h1v12.18c-1.16.41-2 1.51-2 2.82 0 1.65 1.35 3 3 3s3-1.35 3-3c0-.35-.07-.69-.18-1h5.37c-.11.31-.18.65-.18 1 0 1.65 1.35 3 3 3s3-1.35 3-3-1.35-3-3-3zm1.86-9.08L18.13 12H7V6.07zM7 19c0 .55-.45 1-1 1s-1-.45-1-1 .45-1 1-1 1 .45 1 1m10 1c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1"
    />
  </svg>
);
export default SvgShoppingCart;
